
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import SubTitle from "./title-sub.vue";
import Title from "./title.vue";
import { UploadFile } from "../request";
@Component({
  components: {
    Title,
    SubTitle,
  },
})
export default class Name extends Vue {
  @Prop()
  private content: any; // 整个content数据
  @Watch("content", { immediate: true })
  private contentChange() {
    if (this.content) {
      this.cContent = JSON.parse(JSON.stringify(this.content));
    }
  }
  @Prop()
  private index: any; // 当前题目的索引
  @Prop()
  private data: any; // 题目的数据
  @Watch("data", { immediate: true })
  private dataChange() {
    if (this.data) {
      this.c = JSON.parse(JSON.stringify(this.data));
      if (!this.c.value) {
        this.c.value = {
          voices: [],
        };
      } else {
        if (!this.c.value.voices) {
          this.c.value.voices = [];
        }
      }
    }
  }
  @Prop()
  private source: any; //dialog,审核修改弹框;renkouxue,人口学和受试者信息;
  private c: any = {};
  private cContent: any = {}; // 因为不能直接改动prop里面的数据，所以用Ccontent暂存下
  private currentCharacterIndex: number = 0;
  private currentCharacter: string | null = null;
  private recordings: Blob[] = [];
  private isRecording: boolean = false;
  private mediaRecorder: any = null;
  private recordedChunks: Blob[] = [];
  private showAudio: any = false;
  private loading: any = null;
  private timeLeft: any = null; // 初始倒计时时间
  private timerId: any = null; // 定时器ID
  private isClosing: boolean = false; // 添加标志位
  private recordingStream: any = null; // 添加stream引用
  private stopRecordingTimeout: any = null; // 添加录音停止定时器引用
  private isSwitching: boolean = false; // 添加切换状态标志
  private get ifCompose() {
    return this.$store.state.ifCompose;
  }
  private getTextArray(): string[] {
    return "黄虫素石古玉天竹明必".split("");
  }
  private reset() {
    this.startRecordingProcess();
  }
  private resetData() {
    this.c.value.voices = [];
    this.$emit("update", this.c);
    this.showAudio = false;
  }
  private close() {
    this.isClosing = true;
    
    // 清除所有计时器
    if (this.stopRecordingTimeout) {
        clearTimeout(this.stopRecordingTimeout);
        this.stopRecordingTimeout = null;
    }
    this.clearCountdown();
    
    // 停止录音
    if (this.mediaRecorder && this.mediaRecorder.state === "recording") {
        try {
            this.mediaRecorder.stop();
            // 移除事件监听器
            this.mediaRecorder.ondataavailable = null;
            this.mediaRecorder.onstop = null;
        } catch (e) {
            console.log('停止录音失败:', e);
        }
    }
    
    // 释放媒体流
    if (this.recordingStream) {
        this.recordingStream.getTracks().forEach((track: any) => {
            track.stop();
            track.enabled = false;
        });
        this.recordingStream = null;
    }
    
    // 重置状态
    this.mediaRecorder = null;
    this.recordedChunks = [];
    this.timeLeft = null;
    this.timerId = null;
    this.isRecording = false;
    this.currentCharacterIndex = 0;
    this.currentCharacter = null;
    this.recordings = [];
    this.c.value.voices = [];
    this.$emit("update", this.c);
    this.showAudio = false;
    this.isSwitching = false; // 重置切换状态
  }
  private sure() {
    this.showAudio = false;
    this.$emit("save");
  }
  private startRecording() {
    if (this.isClosing) return;
    
    // 确保计时器被清理
    this.clearCountdown();
    
    // 如果正在切换中，等待切换完成
    if (this.isSwitching) {
        setTimeout(() => {
            this.startRecording();
        }, 1000);
        return;
    }
    
    console.log(this.currentCharacter);
    this.isRecording = true;
    this.recordedChunks = [];
    
    navigator.mediaDevices
      .getUserMedia({ audio: true })
      .then((s) => {
        if (this.isClosing) {
            s.getTracks().forEach((track: any) => track.stop());
            return;
        }
        
        this.recordingStream = s;
        this.mediaRecorder = new MediaRecorder(s);
        
        this.mediaRecorder.ondataavailable = (e: any) => {
            this.recordedChunks.push(e.data);
        };
        
        this.mediaRecorder.onstop = () => {
            if (this.isClosing) return;
            
            const blob = new Blob(this.recordedChunks, {
                type: "audio/mp3",
            });
            this.recordings.push(blob);
            
            // 设置切换状态
            this.isSwitching = true;
            
            // 等待一秒后再切换下一个字符
            setTimeout(() => {
                this.isSwitching = false;
                this.nextCharacter();
            }, 1000);
        };
        
        this.mediaRecorder.start();
        // 确保在开始录音时重置并启动计时器
        this.startCountdown();
        
        // 使用变量保存timeout ID
        this.stopRecordingTimeout = setTimeout(() => {
            if (this.mediaRecorder && this.mediaRecorder.state === "recording") {
                this.mediaRecorder.stop();
            }
        }, 4000);
      })
      .catch((err) => {
        console.error("Error accessing media devices:", err);
        this.isRecording = false;
        this.isSwitching = false;
        this.clearCountdown();
      });
  }
  private startCountdown() {
    // 确保之前的计时器被清理
    this.clearCountdown();
    
    // 重置倒计时时间
    this.timeLeft = 3;
    
    // 启动新的计时器
    this.timerId = window.setInterval(() => {
        if (this.timeLeft > 0) {
            this.timeLeft -= 1;
        } else {
            this.clearCountdown();
        }
    }, 1000);
  }
  private clearCountdown() {
    if (this.timerId !== null) {
        clearInterval(this.timerId);
        this.timerId = null;
    }
    // 确保timeLeft被重置
    this.timeLeft = null;
  }
  private nextCharacter() {
    if (this.isClosing) return;

    this.currentCharacterIndex++;
    if (this.currentCharacterIndex < this.getTextArray().length) {
      this.currentCharacter = this.getTextArray()[this.currentCharacterIndex];
      console.log("继续");
      this.startRecording();
    } else {
      console.log("结束");
      this.uploadRecordings();
    }
  }

  private uploadRecordings() {
    console.log(this.recordings);
    this.loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    this.uploadNextRecording(0); // 从第一个录制文件开始上传
  }
  private uploadNextRecording(index: number) {
    if (index >= this.recordings.length) {
      // 所有文件都已上传完毕
      console.log("All recordings uploaded.");
      this.isRecording = false;
      this.loading.close();
      console.log(this.c);
      // 保存
      // this.$emit("save");
      return;
    }

    const currentRecording = this.recordings[index];
    this.upload(currentRecording)
      .then((uploadResult) => {
        // 上传成功后的处理逻辑（如果需要）
        console.log(`Uploaded recording ${index + 1}:`, uploadResult);
        // 递归调用上传下一个录制文件
        this.uploadNextRecording(index + 1);
      })
      .catch((error) => {
        // 上传失败的处理逻辑
        this.loading.close();
        console.error(`Failed to upload recording ${index + 1}:`, error);
        // 根据需求，可以选择停止上传或者重试上传当前文件
        // 这里简单地停止上传
      });
  }
  private upload(d: any) {
    return new Promise((resolve, reject) => {
      // 将 photoData 转换为 Blob 对象
      // 获取当前时间的时间戳（毫秒级）
      const timestamp = Date.now();
      const filename = `${timestamp}.mp3`;
      // FormData 对象
      const form = new FormData();
      // Blob 对象作为文件添加到表单中
      form.append("file", d, filename); // 可以指定文件名

      UploadFile(this, form)
        .then((res: any) => {
          this.c.value.voices.push(res.data);
          this.$emit("update", this.c);
          resolve(res.data);
        })
        .catch(() => {
          this.loading.close();
          reject();
        });
    });
  }

  private startRecordingProcess() {
    // 重置所有状态
    this.isClosing = false;
    this.isSwitching = false;
    this.currentCharacterIndex = 0;
    this.currentCharacter = null;
    this.recordings = [];
    this.isRecording = false;
    this.mediaRecorder = null;
    this.recordingStream = null;
    this.recordedChunks = [];
    this.timeLeft = null;
    this.timerId = null;
    this.c.value.voices = [];
    
    // 开始新的录音流程
    this.showAudio = true;
    this.currentCharacter = this.getTextArray()[this.currentCharacterIndex];
    this.startRecording();
  }

  private resetRecording() {
    // 先执行关闭操作，确保当前录音完全停止
    this.close();
    
    // 确保计时器被清理
    this.clearCountdown();
    
    // 等待一小段时间确保资源完全释放
    setTimeout(() => {
        // 开始新的录音流程
        this.startRecordingProcess();
    }, 100);
  }
}
